import React, { useState, useEffect } from "react";
import { Empty, Spin, Pagination } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import DocumentCard from "../DocumentCard";

const DocumentGrid = ({
  documents = [],
  loading = false,
  pagination = {},
  onPageChange,
  onDelete,
  onDownload,
  onRefresh,
}) => {

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spin size="large" />
      </div>
    );
  }

  if (documents.length === 0) {
    return (
      <div className="flex justify-center items-center h-64">
        <Empty
          image={<InboxOutlined style={{ fontSize: 60 }} />}
          description={
            <span>
              No documents found
              <br />
              <span className="text-sm text-gray-400">
                Upload your first document to get started
              </span>
            </span>
          }
        />
      </div>
    );
  }

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {documents.map((doc) => (
          <DocumentCard
            key={doc._id}
            document={doc}
            onDelete={onDelete}
            onDownload={onDownload}
          />
        ))}
      </div>

      {pagination.totalPages > 1 && (
        <div className="mt-6 flex justify-center">
          <Pagination
            current={pagination.currentPage}
            total={pagination.totalCount}
            pageSize={pagination.pageSize || 20}
            onChange={onPageChange}
            showSizeChanger={false}
          />
        </div>
      )}
    </>
  );
};

export default DocumentGrid;